// JavaScript Document

//获取相对位置
function getOffsetToBody(node, scroll) {
    var top = 0,
        left = 0;
    var getOffset = function(dom, scroll) {
        top += dom.offsetTop;
        left += dom.offsetLeft;
        if (scroll) {
            top -= dom.scrollTop;
            left -= dom.scrollLeft;
        }
        if (dom.offsetParent) {
            getOffset(dom.offsetParent, scroll);
        }

    };
    getOffset(node, scroll);
    return {
        top: top,
        left: left
    }
}

function commonFormatDate(x,y){//x是时间类型，y是你想要的输出形式，例如：$scope.applicationDate=getDate(new Date($scope.applicationDate),"yyyy-MM-dd");
		var z = {M:x.getMonth()+1,d:x.getDate(),h:x.getHours(),m:x.getMinutes(),s:x.getSeconds()}; 
		y = y.replace(/(M+|d+|h+|m+|s+)/g,function(v) {return ((v.length>1?"0":"")+eval('z.'+v.slice(-1))).slice(-2)}); 
		return y.replace(/(y+)/g,function(v) {return x.getFullYear().toString().slice(-v.length)}); 	
}
function getStringDate(date){
	if(date == null){
		date = new Date();
	}
	var month = date.getMonth() + 1;
	if(month < 10){
		month = "0" + month.toString();
	}
	
//	var day = date.getDay(); 这特么！getDay()获取的是月数，getDate()获取的是天数！ca!
	var day = date.getDate();
	if(day < 10){
		day = "0" + day;
	}
	
	var hour = date.getHours();
	if(hour < 10){
		hour = "0" + hour;
	}
	
	var min = date.getMinutes();
	if(min < 10){
		min = "0" + min;
	}	
	
	var sec = date.getSeconds();
	if(sec < 10){
		sec = "0" + sec;
	}	
	
	return date.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
}


//返回年月日
function getYMD(date){
	if(date == null){
		date = new Date();
	}
	var month = date.getMonth() + 1;
	if(month < 10){
		month = "0" + month.toString();
	}
	
	var day = date.getDate();
	if(day < 10){
		day = "0" + day;
	}
	
	return date.getFullYear() + "-" + month + "-" + day;
}

// 获取指定日期开始时间
function getDate0Clock(date) {
	if(date) {
		date = new Date(date);
	} else {
		date = new Date();
	}
	date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
	return date;
}

// 获取指定日期结束时间
function getDate24Clock(date) {
	if(date) {
		date = new Date(date);
	} else {
		date = new Date();
	}
	date.setHours(23);
    date.setMinutes(59);
    date.setSeconds(59);
    date.setMilliseconds(999);
	return date;
}

// 在指定日期增加天数得到日期
function addDays(date, add) {
	if(date) {
		date = new Date(date);
	} else {
		date = new Date();
	}
	return parseDate(date.getTime() + add*24*60*60*1000);
}

// 获取本周开始时间（以周一为一周开始）
function getWeekStartDate(date) {
	if(date) {
		date = new Date(date);
	} else {
		date = new Date();
	}
	var nowDayOfWeek = date.getDay(); 
	
	//将周日转为一周结束
	if(nowDayOfWeek == 0) {
		nowDayOfWeek = 6;
	} else {
		nowDayOfWeek = nowDayOfWeek - 1;
	}
	
	var weekStartDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - nowDayOfWeek); 
	return getDate0Clock(weekStartDate); 
}

// 获取本周结束时间（以周一为一周开始）
function getWeekEndDate(date) {
	if(date) {
		date = new Date(date);
	} else {
		date = new Date();
	}
	var nowDayOfWeek = date.getDay();
	
	//将周日转为一周结束
	if(nowDayOfWeek == 0) {
		nowDayOfWeek = 6;
	} else {
		nowDayOfWeek = nowDayOfWeek - 1;
	}
	
	var weekEndDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + (6 - nowDayOfWeek));
	return getDate24Clock(weekEndDate);
}

//返回年月日
function getPreYMD(date){
	if(date == null){
		date = new Date();
	}
	date.setMonth(date.getMonth()-1);
	var month = date.getMonth() + 1;
	if(month < 10){
		month = "0" + month.toString();
	}
	
	var day = date.getDate();
	if(day < 10){
		day = "0" + day;
	}
	
	return date.getFullYear() + "-" + month + "-" + day;
}

//返回年月日
function getDateDesc(date){
	if(date == null){
		date = new Date();
	}
	var month = date.getMonth() + 1;
	if(month < 10){
		month = "0" + month.toString();
	}
	
	var day = date.getDate();
	if(day < 10){
		day = "0" + day;
	}
	
	return date.getFullYear() + "年" + month + "月" + day + "日";
}
//返回年月日减一天
function getDateDescLessDay(date){
	if(date == null){
		date = new Date();
	}
	
	var month = date.getMonth() + 1;
	var year = date.getFullYear();
	var day = date.getDate();
	if(day>1){
		  day = day-1;
	  }else if(day==1){
		  if(month>1){
			  month = month-1;
			  switch(month)
			  {
			  case 1: 
			  case 3:
			  case 5:
			  case 7:
			  case 8:
			  case 10:
			  case 12:
				  day = 31;
			  case 4:
			  case 6:
			  case 9:
			  case 11:
				  day = 30;
			  case 2:
			  if((year%4!=0)||((year%100==0)&&(year%400!=0)))
				  day = 28;
			  else
				  day = 29;
			  default:
				  day = 0;
			  };
		  }else if(month==1){
			  year = year-1;
			  month = 12;
			  day = 31;
		  }
	  }
	if(month < 10){
		month = "0" + month.toString();
	}
	if(day < 10){
		day = "0" + day;
	}
	return date.getFullYear() + "年" + month + "月" + day + "日";
}

/**
 * 操作时间与服务器时间比较返回显示结果，如果XX>24h返回 '年-月-日 时：分'，如果24h>=XX>=1h返回'XX小时之前'，如果1h>XX 则返回'XX分钟之前'
 * @param operaDate 需要处理的时间,类型为Date
 * @param currDate 服务器时间,类型为Date
 * @returns {String} eg：1分钟之前
 */
function dealWithTime(operaDate,currDate){
	var _m = moment(operaDate);
	var _d = currDate - 3*86400000//3天前
	if(operaDate>_d){
		return _m.fromNow();
	}else{
		return _m.format("l HH:mm");
	} 
//	
//	if(currDate == null)
//		return "当前时间为空";
//	if(operaDate == null)
//		return "创建时间为空";
//	if(typeof operaDate == 'number'){
//		operaDate=new Date(operaDate);
//	}
//	if((currDate-operaDate)/1000/60 < 1){
//		return "1分钟之前";
//	}else if((currDate-operaDate)/1000/60 >= 1 && (currDate-operaDate)/1000/60 < 60){
//		var time = (currDate-operaDate)/1000/60
//		time = time.toString().split(".")[0];
//		return time+"分钟之前";
//	}else if((currDate-operaDate)/1000/60/60 >= 1 && (currDate-operaDate)/1000/60/60 <24){
//		var time = (currDate-operaDate)/1000/60/60;
//		time = time.toString().split(".")[0];
//		return time+"小时之前";
//	}else{
//		return operaDate.getFullYear()+"-"
//			+((operaDate.getMonth()+1)<10?("0"+(operaDate.getMonth()+1)):(operaDate.getMonth()+1))+"-"
//			+(operaDate.getDate()<10?("0"+operaDate.getDate()):operaDate.getDate())+" "
//			+(operaDate.getHours()<10?("0"+operaDate.getHours()):operaDate.getHours())+":"
//			+(operaDate.getMinutes()<10?("0"+operaDate.getMinutes()):operaDate.getMinutes());
//	}
}

/**
 * 作用：解决“内联对象”数据提交的问题，传入老的JSON对象和新的数据，返回完整的、后台可以接收的JSON
 * 
 * oldJSON：JSON对象-除“内联对象”外的其他参数JSON对象
 * row：字符串-“内联对象”在主对象中的字段名（如：iquicker_model项目中com.dc.iquicker.model.discuss.Discuss类的变量attList，在这里应该是“attachments”）
 * cols：数组-包括“内联对象”自己的所有变量名（如：iquicker_model项目中com.dc.iquicker.model.discuss.Attachment类的变量，在传入本方法之前这样定义：var cols = ["file_name", "file_path", "file_type"];）
 * values：数组套数组-多个“内联对象”在页面上获取的数值  所组成的数组（顺序要和cols的变量名顺序一致，如：var values = [[file_name,file_path,file_type],[file_name,file_path,file_type]];）
 * 切记：values的内部数组 是放“内联对象”的值的，值的顺序 要和 cols相对应
 */
function getUintJSON(oldJSON, row, cols, values){
	var vlen = values.length;
	for(var i=0; i<vlen; i++){
		var clen = cols.length;
		for(var j=0; j<clen; j++){
			var newCol =  row + "[" +  i + "]." + cols[j];
			oldJSON[newCol] = (values[i])[j];
		}
	}
	
	return oldJSON;
}

function transBeforeSave(content){
	content = content.replace(new  RegExp(" ", "g"),"&nbsp;");//空格替换
//	//表情处理
//	var reg = new RegExp("\\[[^\\]]*\\]","g"); //创建正则RegExp对象    
//	var faces = content.match(reg);
//	if(faces != null){
//		for (var j=0;j<faces.length;j++) {
////			alert(faces[j]);
//			var imgPath = null;
//			var faceBase = ImgIputHandler.facePath;
//			for(var k=0;k<faceBase.length;k++){
//				var key = "[" + faceBase[k].faceName + "]";
//				if(key == faces[j]){//如果表情库的faceName等于匹配到的表情代码
//					imgPath = faceBase[k].facePath;
//					break;
//				}
//			}
//			
//			if(imgPath == null){//如果没有找到表情
//				
//			}else{
////				content = content.replace(faces[j], "<img src=\"img/face/" + imgPath +  "\"/>");//替换表情代码为表情图片链接
//				content = content.replace(faces[j], "<img src=\"" + imgPath +  "\"/>");//替换表情代码为表情图片链接
//			}
//			
//		}
//	}

	
//	//#处理
//	var regJing = new RegExp("#[^#\\s&]*#","g"); //创建正则RegExp对象    
//	var jings = content.match(regJing);
//	if(jings != null){
//		for (var m=0;m<jings.length;m++) {
////			content = content.replace(jings[m], "<a target=\"_blank\" href=\"" + "#/topic" + "\">" + jings[m] + "</a>");
//
//			content = content.replace(jings[m], "<a class=\"talk-subject-textcolor ng-binding ng-scope\" href=\"javascript:void(0)\" ng-click=\"topicRelations(topic.id, topic.topic)\">" + jings[m] + "</a>");
//		}
//	}

	
//	//@处理
//	var regAt = new RegExp("@[^@\\s&]*","g"); //创建正则RegExp对象    
//	var ats = content.match(regAt);
//	if(ats != null){
//		for (var n=0;n<ats.length;n++) {
//			content = content.replace(ats[n], "<a target=\"_blank\" href=\"" + "javascript:void(0)" + "\">" + ats[n] + "</a>");
//		}
//	}

return content;
}


/**
 * 将数组对象封装json对象  [{createUser:'user1',shareUserId:'per1',shareUserName:'per1'}] 封装成 {'shareUsers[0].createUser':'user1', 'shareUsers[0].shareUserId':'per1', 'shareUsers[0].shareUserName':'per1'} 
 * list :数组
 * listName :在javaBean中的集合变量名称
 * target :目标对象，可为空
 * return 目标对象
 */
var getListParam=function (list,listName,target){
	if(target==null){
		target={};
	}
	angular.forEach(list, function(record, i) {
		angular.forEach(record, function(val,key){
			target[listName+'['+i+'].'+key+''] = val;
			console.log(target[listName+'['+i+'].'+key+'']);
		});
	});
	return target;
} 

/** 
 * 得到某个日期所在周的周一日期和周五日期
 * @param 日期 
 * @author wangchk
 * @date 2015-6-10 
 * */  
function getMonDayAndSunDay(date){
	if(date == null){
		date = new Date();
	}
	var year = date.getFullYear();
	var month = date.getMonth();
	var day = date.getDate();
  
    var dateOfWeek = date.getDay();//返回当前日期的在当前周的某一天（0～6--周日到周一）  
  
    var dateOfWeekInt = parseInt(dateOfWeek,10);//转换为整型  
  
    if(dateOfWeekInt==0){//如果是周日  
        dateOfWeekInt=7;  
    }  
    var disDay = 7-dateOfWeekInt;//当前于周末相差的天数  
  
    var cday = parseInt(day,10);//按10进制转换，以免遇到08和09的时候转换成0  
    var sunDay = cday+disDay;//当前日期的周日的日期  
    var monDay = sunDay-6//当前日期的周一的日期  
  
    var startDate = new Date(year,month,monDay);  
    var endDate = new Date(year,month,sunDay-2);  
    var result = new Array();  
    result.push(startDate);  
    result.push(endDate);  
    return result;  
}  

//js获取iquicker->home路径
function getIquickerPath(){
    var curWwwPath=window.document.location.href;
    var pathName=window.document.location.pathname;
    var pos=curWwwPath.indexOf(pathName);
    var localhostPath=curWwwPath.substring(0,pos);
    return(localhostPath+"/home/");
}
//js获取iquicker_web项目路径
function getIquickerWebPath(){
    var curWwwPath=window.document.location.href;
    var pathName=window.document.location.pathname;
    var pos=curWwwPath.indexOf(pathName);
    var localhostPaht=curWwwPath.substring(0,pos);
    return(localhostPaht+"/iquicker_web/");
}


//根据当前日期得到当前月,如2015/06/11 -- 2015/06
function getCurrYM(date){
	if(date == null){
		date = new Date();
	}
	var month = date.getMonth() + 1;
	if(month < 10){
		month = "0" + month.toString();

	}
	return date.getFullYear() + "-" + month ;
}

//获取两个日期之间相差的天数
function GetDateDiff(startDate,endDate){  
    var startTime = new Date(Date.parse(startDate.replace(/-/g,   "/"))).getTime();     
    var endTime = new Date(Date.parse(endDate.replace(/-/g,   "/"))).getTime();     
    var dates = Math.abs((startTime - endTime))/(1000*60*60*24);     
    return  dates;    
}

//根据当前日期得到上个月，如2015/06/11 -- 2015/05
function getPreYM(date){
	if(date == null){
		date = new Date();
	}

	var d=new Date(date.getFullYear(),date.getMonth()-1,date.getDate());
	
	var month = d.getMonth()+1;
	if(month < 10){
		month = "0" + month.toString();

	}
	return d.getFullYear() + "/" + month ;
}
//去除数组中的某个元素
function removeElementById(list, obj){

	for(var i=0,j=0; i<list.length; i++,j++){
		list[j] = list[i];
		if(list[i].id == obj.id){
			j--;
		}
	}
	list.length = list.length-1;
	return list;
}

//是否闰年
function isLeapYear () {
	year = new Date().getYear();
	year += (year < 2000 ? 1900 : 0);
	return (year % 4==0 && year % 100!=0 || year % 400==0);
}
//格式化时间
function formatDate(date) {
	myyear = date.getFullYear();
	mymonth = date.getMonth()+1;
	myweekday = date.getDate();
	return (myyear + "-" + mymonth + "-" + myweekday);
}
//获取最近两周的时间
function nearlyTwoWeek() {
	beginday = 0;
	var dayarray = new Array(31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);
	dayarray[1] = (isLeapYear()) ? 29 : 28;
	dayfactor = 86400000; // one day equals 86400000 milliseconds
	weekstart = new Date();
	weekend = new Date();
//	while (weekstart.getDay() != beginday) {
//		weekstart.setTime(weekstart.getTime() - dayfactor);
//	}
//	weekend.setTime(weekend.getTime() + 6*dayfactor);
	weekstart.setTime(weekstart.getTime() - 14*dayfactor);
	return [formatDate(weekstart),formatDate(weekend)];
}

//获取最近三个月的时间
function nearlyThreeMonth() {
	var	date = new Date();
	
	var year = date.getFullYear();
	var month = date.getMonth() + 1;
	
	month = month - 3;
	if(month < 1){
		year = year - 1;
		month = 12 + month;
	}
	
	if(month < 10){
		month = "0" + month.toString();
	}
	
	var day = date.getDate();
	if(day < 10){
		day = "0" + day;
	}
	
	var startTime = year + "-" + month + "-" + day;
	var startMonth = date.getMonth() + 1;
	if(startMonth < 10){
		startMonth = "0" + startMonth.toString();
	}
	var endTime = date.getFullYear() + "-" + startMonth + "-" + day;
	return [startTime,endTime];
}

//去左空格;
function ltrim(s){
    return s.replace(/(^\s*)/g, "");
}
//去右空格;
function rtrim(s){
    return s.replace(/(\s*$)/g, "");
}
//去左右空格;
function trim(s){
    return s.replace(/(^\s*)|(\s*$)/g, "");
}



//判断是否存在全角半角
//True 没有全角，False有全角
function JudgeCase(str){
    for (var i = 0; i < str.length; i++){
        var strCode = str.charCodeAt(i);
        if (strCode > 0 && strCode < 128){
            return false;
        }
    }
    return true;
}


//判断字符串长度，全角一个字，半角为半个字
function JudgeLength(str){
  var sum = 0;
  for (var i = 0; i < str.length; i++){
      var strCode = str.charCodeAt(i);
      if (strCode > 0 && strCode < 128){
    	  sum += 0.5;
      }else{
    	  sum += 1;
      }
  }
  return sum;
}

/**
 * 消息中心客户端接口
 * author : wangchk
 * date : 2015/11/25
 */
var socketIOClient;
var socketIO=function(){
	
	Pace.start({
		  ajax: {
			    ignoreURLs: [/socket\.io/]
			  }
		})
	/**
	 * 得到当前连接的实例
	 */
	function getSocket(callback){
		if(!socketIOClient || socketIOClient.disconnected){
			return cennectServer(callback);
		}
		return socketIOClient;
	}
	/**
	 * 连接socketIOClientio服务器
	 * param : callback 成功连接上服务器回调函数
	 */
	function cennectServer(callback){
//		var serverIP= location.protocol + "//" + location.hostname + ":" + location.port;
		var hostname = '10.0.2.85';//http://testwww.iquicker.com.cn/
		if(location.hostname =='localhost' || location.hostname =='127.0.0.1'){
			hostname = location.hostname;
		}
		var serverIP= location.protocol + "//" + hostname + ":" + '40000';
//		var serverIP='http://testwww.iquicker.com.cn/';
		
//		console.log("------"+serverIP);
		socketIOClient = io.connect(serverIP+'/notice');
		socketIOClient.on('connect', function() {
//			console.log("----Client has connected to the server!------");
			if (callback) {
				callback();
			}
		});
		return socketIOClient;
	}
	
	/**
	 * 监听服务器端发送消息事件，
	 * callback 回调函数，由应用自己调用
	 * id 当前用户id，用于接收的消息是否是发给自己的
	 */
	function createNoticeListener(id,callback){
		getSocket();
		socketIOClient.on(id, function(data){
			console.log("------receive_notice_event------",data);
			//有新的消息发送过来并且是‘我的’才执行回调
			if(callback){
				callback(data);
			}
			
		});
	}
	
	/**
	 * 客户端向服务器端发送消息事件，客户端应用发送通知时调用该方法
	 * param : jsonObject 发送到服务器的message,json对象,对应属性{ type: 0, read: false,ids: sendUsers}
	 * param : callback 发送消息成功后回调函数
	 */
	function sendNoticeEvent(jsonObject,callback){
		getSocket();
		socketIOClient.emit('send_notice_event', jsonObject, function(arg1, arg2) {
			console.log("-----客户端向服务器端发送消息----",arg1);
			if(callback){
				callback();
			}
		});
	}
	
	return {
			cennectServer : cennectServer,
			createNoticeListener : createNoticeListener,
			sendNoticeEvent : sendNoticeEvent,
			getSocket : getSocket
	}
}

//处理url方法
function queryUrl(params){
	if (typeof params == 'string') {
		var obj = {};
			var reg = /([^=&?]+)=([^=&?]+)/g
			params.replace(reg,function(item){
				var key = item.split('=')[0];
				var value = item.split('=')[1];
				obj[key] = value;
			})
			return obj;
		}else{
			var str = '';
			for(var key in params){
				str += (key + "=" + params[key] + "&")
			}
			str = str.substr(0,str.length-1);
			return str;
		}
}

var regexProcessor=function(str){
	if(!str){
		str = str;
	}
	if(str.indexOf("\\")!=-1){
		str=str.replace(/\\/g,'\\\\')
	}
	
	if(str.indexOf("$")!=-1){
		str=str.replace(/\$/g,'\\$')
	}
	
	if(str.indexOf("*")!=-1){
		str=str.replace(/\*/g,'\\*')
	}
	
	if(str.indexOf("?")!=-1){
		str=str.replace(/\?/g,'\\?')
	}
	
	if(str.indexOf("^")!=-1){
		str=str.replace(/\^/g,'\\^')
	}
	
	if(str.indexOf("[")!=-1){
		str=str.replace(/\[/g,'\\[')
	}
	if(str.indexOf("{")!=-1){
		str=str.replace(/\{/g,'\\{')
	}
	if(str.indexOf("(")!=-1){
		str=str.replace(/\(/g,'\\(')
	}
	
	if(str.indexOf(".")!=-1){
		str=str.replace(/\./g,'\\.')
	}
	if(str.indexOf("+")!=-1){
		str=str.replace(/\+/g,'\\+')
	}
	
	if(str.indexOf("|")!=-1){
		str=str.replace(/\|/g,'\\|')
	}
	return str;
}

var emojiLiArrs = ["<li><span title='大笑' class='face0'></li>"+"<li><span title='白眼' class='face1'></li>"+"<li><span title='猪' class='face2'></li>"+"<li><span title='微笑' class='face3'></li>"+"<li><span title='害羞' class='face4'></li>"+"<li><span title='可爱' class='face5'></li>"+"<li><span title='色' class='face6'></li>"+"<li><span title='飞吻' class='face7'></li>"+"<li><span title='亲亲' class='face8'></li>"+"<li><span title='调皮' class='face11'></li>"+"<li><span title='吐舌头' class='face12'></li>"+"<li><span title='发呆' class='face14'></li>"+"<li><span title='龇牙' class='face15'></li>"+"<li><span title='不屑' class='face16'></li>"+"<li><span title='傲慢' class='face17'></li>"+"<li><span title='鄙视' class='face18'></li>"+"<li><span title='衰' class='face19'></li>"+"<li><span title='难过' class='face20'></li>"+"<li><span title='笑喷' class='face22'></li>"+"<li><span title='流泪' class='face23'></li>"+"<li><span title='折磨' class='face24'></li>"+"<li><span title='冷汗' class='face25'></li>"+"<li><span title='惊恐' class='face26'></li>"+"<li><span title='流汗' class='face27'></li>"+"<li><span title='尴尬' class='face28'></li>"+"<li><span title='大哭' class='face29'></li>"+"<li><span title='抓狂' class='face30'></li>"+"<li><span title='害怕' class='face32'></li>"+"<li><span title='愤怒' class='face34'></li>"+"<li><span title='发怒' class='face35'></li>"+"<li><span title='生病' class='face39'></li>"+"<li><span title='得意' class='face40'></li>"+"<li><span title='困' class='face41'></li>"+"<li><span title='晕' class='face43'></li>"+"<li><span title='委屈' class='face44'></li>"+"<li><span title='坏笑' class='face47'></li>"+"<li><span title='小恶魔' class='face48'></li>"+"<li><span title='惊讶' class='face49'></li>"+"<li><span title='闭嘴' class='face51'></li>"+"<li><span title='撇嘴' class='face52'></li>"+"<li><span title='酷' class='face56'></li>"+"<li><span title='老板' class='face58'></li>"+"<li><span title='跑腿小弟' class='face64'></li>"+"<li><span title='跑堂小妹' class='face65'></li>"+"<li><span title='天使' class='face71'></li>"+"<li><span title='憨笑' class='face74'></li>"+"<li><span title='阴险' class='face77'></li>"+"<li><span title='吓' class='face78'></li>",
    "<li><span title='可怜' class='face79'></li>"+"<li><span title='不要看' class='face84'></li>"+"<li><span title='投降' class='face85'></li>"+"<li><span title='偷笑' class='face86'></li>"+"<li><span title='骷髅' class='face87'></li>"+"<li><span title='外星人' class='face88'></li>"+"<li><span title='屎' class='face89'></li>"+"<li><span title='火焰' class='face90'></li>"+"<li><span title='发光' class='face91'></li>"+"<li><span title='星星' class='face92'></li>"+"<li><span title='Bang！' class='face94'></li>"+"<li><span title='雨水' class='face96'></li>"+"<li><span title='睡觉' class='face98'></li>"+"<li><span title='吹起' class='face99'></li>"+"<li><span title='赞' class='face105'></li>"+"<li><span title='真挫' class='face106'></li>"+"<li><span title='拳头' class='face108'></li>"+"<li><span title='耶' class='face110'></li>"+"<li><span title='鼓掌' class='face121'></li>"+"<li><span title='强' class='face122'></li>"+"<li><span title='快跑' class='face124'></li>"+"<li><span title='跳舞' class='face125'></li>"+"<li><span title='男女' class='face126'></li>"+"<li><span title='一家人' class='face127'></li>"+"<li><span title='亲亲我我' class='face130'></li>"+"<li><span title='兔女郎' class='face132'></li>"+"<li><span title='OK' class='face133'></li>"+"<li><span title='NO' class='face134'></li>"+"<li><span title='举手' class='face136'></li>"+"<li><span title='按摩' class='face137'></li>"+"<li><span title='剪发' class='face138'></li>"+"<li><span title='思考' class='face143'></li>"+"<li><span title='王冠' class='face145'></li>"+"<li><span title='比基尼' class='face159'></li>"+"<li><span title='眼镜' class='face164'></li>"+"<li><span title='礼物' class='face165'></li>"+"<li><span title='雨伞' class='face166'></li>"+"<li><span title='红心' class='face172'></li>"+"<li><span title='心碎' class='face173'></li>"+"<li><span title='心' class='face176'></li>"+"<li><span title='丘比特' class='face179'></li>"+"<li></li>"+"<li></li>"+"<li></li>"+"<li></li>"+"<li></li>"+"<li></li>"+"<li></li>"
];


var emojinetdiskLiArrs = ["<li><span title='大笑' class='face0'></li>"+
				   "<li><span title='白眼' class='face1'></li>"+
				   "<li><span title='猪' class='face2'></li>"+
				   "<li><span title='微笑' class='face3'></li>"+
				   "<li><span title='害羞' class='face4'></li>"+
				   "<li><span title='可爱' class='face5'></li>"+
				   "<li><span title='色' class='face6'></li>"+
				   "<li><span title='飞吻' class='face7'></li>"+
				   "<li><span title='亲亲' class='face8'></li>"+
				   "<li><span title='调皮' class='face11'></li>"+
				   "<li><span title='吐舌头' class='face12'></li>"+
				   "<li><span title='发呆' class='face14'></li>"+
				   "<li><span title='龇牙' class='face15'></li>"+
				   "<li><span title='不屑' class='face16'></li>"+
				   "<li><span title='傲慢' class='face17'></li>"+
				   "<li><span title='鄙视' class='face18'></li>"+
				   "<li><span title='衰' class='face19'></li>"+
				   "<li><span title='难过' class='face20'></li>"+
				   "<li><span title='笑喷' class='face22'></li>"+
				   "<li><span title='流泪' class='face23'></li>"+
				   "<li><span title='折磨' class='face24'></li>"+
				   "<li><span title='冷汗' class='face25'></li>"+
				   "<li><span title='惊恐' class='face26'></li>"+
				   "<li><span title='流汗' class='face27'></li>"+
				   "<li><span title='尴尬' class='face28'></li>"+
				   "<li><span title='大哭' class='face29'></li>"+
				   "<li><span title='抓狂' class='face30'></li>"+
				   "<li><span title='害怕' class='face32'></li>"+
				   "<li><span title='愤怒' class='face34'></li>"+
				   "<li><span title='发怒' class='face35'></li>"+
				   "<li><span title='生病' class='face39'></li>"+
				   "<li><span title='得意' class='face40'></li>"+
				   "<li><span title='困' class='face41'></li>"+
				   "<li><span title='晕' class='face43'></li>"+
				   "<li><span title='委屈' class='face44'></li>"+
				   "<li><span title='坏笑' class='face47'></li>",
				   "<li><span title='小恶魔' class='face48'></li>"+
				   "<li><span title='惊讶' class='face49'></li>"+
				   "<li><span title='闭嘴' class='face51'></li>"+
				   "<li><span title='撇嘴' class='face52'></li>"+
				   "<li><span title='酷' class='face56'></li>"+
				   "<li><span title='老板' class='face58'></li>"+
				   "<li><span title='跑腿小弟' class='face64'></li>"+
				   "<li><span title='跑堂小妹' class='face65'></li>"+
				   "<li><span title='天使' class='face71'></li>"+
				   "<li><span title='憨笑' class='face74'></li>"+
				   "<li><span title='阴险' class='face77'></li>"+
				   "<li><span title='吓' class='face78'></li>"+
				   "<li><span title='可怜' class='face79'></li>"+
				   "<li><span title='不要看' class='face84'></li>"+
				   "<li><span title='投降' class='face85'></li>"+
				   "<li><span title='偷笑' class='face86'></li>"+
				   "<li><span title='骷髅' class='face87'></li>"+
				   "<li><span title='外星人' class='face88'></li>"+
				   "<li><span title='屎' class='face89'></li>"+
				   "<li><span title='火焰' class='face90'></li>"+
				   "<li><span title='发光' class='face91'></li>"+
				   "<li><span title='星星' class='face92'></li>"+
				   "<li><span title='Bang！' class='face94'></li>"+
				   "<li><span title='雨水' class='face96'></li>"+
				   "<li><span title='睡觉' class='face98'></li>"+
				   "<li><span title='吹起' class='face99'></li>"+
				   "<li><span title='赞' class='face105'></li>"+
				   "<li><span title='真挫' class='face106'></li>"+
				   "<li><span title='拳头' class='face108'></li>"+
				   "<li><span title='耶' class='face110'></li>"+
				   "<li><span title='鼓掌' class='face121'></li>"+
				   "<li><span title='强' class='face122'></li>"+
				   "<li><span title='快跑' class='face124'></li>"+
				   "<li><span title='跳舞' class='face125'></li>"+
				   "<li><span title='男女' class='face126'></li>"+
				   "<li><span title='一家人' class='face127'></li>",
				   "<li><span title='亲亲我我' class='face130'></li>"+
                   "<li><span title='兔女郎' class='face132'></li>"+
                   "<li><span title='OK' class='face133'></li>"+
                   "<li><span title='NO' class='face134'></li>"+
                   "<li><span title='举手' class='face136'></li>"+
                   "<li><span title='按摩' class='face137'></li>"+
                   "<li><span title='剪发' class='face138'></li>"+
                   "<li><span title='思考' class='face143'></li>"+
                   "<li><span title='王冠' class='face145'></li>"+
                   "<li><span title='比基尼' class='face159'></li>"+
                   "<li><span title='眼镜' class='face164'></li>"+
                   "<li><span title='礼物' class='face165'></li>"+
                   "<li><span title='雨伞' class='face166'></li>"+
                   "<li><span title='红心' class='face172'></li>"+
                   "<li><span title='心碎' class='face173'></li>"+
                   "<li><span title='心' class='face176'></li>"+
                   "<li><span title='丘比特' class='face179'></li>"+
                   "<li></li>"+"<li></li>"+"<li></li>"+"<li></li>"+"<li></li>"+"<li></li>"+"<li></li>"+"<li></li>"+"<li></li>"+"<li></li>"+"<li></li>"+"<li></li>"+"<li></li>"+"<li></li>"+"<li></li>"+"<li></li>"+"<li></li>"+"<li></li>"+"<li></li>"+"<li></li>"];



